import { Employee } from "../employee-list";
import React from "react";
import profileImg from ".././media/dr-ule-pfeiffer.jpg";
import i18n from "../../../generic/i18n";

export const drUlePfeiffer: Employee = {
  slug: "dr-ule-pfeiffer",
  displayName: "Dr. Ule Pfeiffer",
  displayNameSuffix: "LL.M.",
  title: "lawyer-male",
  isExternal: true,
  subTitle: "",
  awards: [],
  img: profileImg,
  languages: ["deu", "eng"],
};
